export const glossary = [
  { term: "Recuar", category: "Ação", definition: "Mover seu Pokémon Ativo para o Banco pagando o custo de recuo (Energias anexadas)." },
  { term: "Fraqueza", category: "Status", definition: "Aumenta o dano recebido de tipos específicos (geralmente x2)." },
  { term: "Resistência", category: "Status", definition: "Diminui o dano recebido de tipos específicos (geralmente -30)." },
  { term: "Habilidade", category: "Mecânica", definition: "Efeitos especiais que um Pokémon pode ter, que não são ataques." },
  { term: "Nocaute (KO)", category: "Ação", definition: "Quando um Pokémon tem dano acumulado igual ou superior ao seu HP." }
];

export const faq = [
  { q: "Posso evoluir um Pokémon no primeiro turno?", a: "Não, você deve esperar pelo menos um turno após o Pokémon entrar em jogo para evoluí-lo (exceto por efeitos de cartas)." },
  { q: "Quantas cartas de Treinador posso usar por turno?", a: "Você pode usar quantas cartas de Itens quiser, mas apenas uma carta de Apoiador por turno." }
];
